import { SvgIcon, type SvgIconProps } from '@material-ui/core';

export const NewItemBadgeIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 169 79" titleAccess="New item">
    <rect x="17.0708" y="19.6311" width="120.348" height="47.798" fill="#fff" />
    <path
      d="M168.31 71.1144L148.967 38.6246L168.113 7.4599C168.567 6.71725 168.815 5.86782 168.831 4.99851C168.848 4.12921 168.631 3.27124 168.205 2.51238C167.778 1.75352 167.156 1.12102 166.403 0.679581C165.65 0.238143 164.793 0.00361778 163.919 0H9.86866C7.25133 0 4.7412 1.03415 2.89046 2.87494C1.03973 4.71573 0 7.21238 0 9.81566L0 68.7096C0 71.3129 1.03973 73.8095 2.89046 75.6503C4.7412 77.4911 7.25133 78.5253 9.86866 78.5253H164.067C164.937 78.5251 165.793 78.2957 166.546 77.8603C167.299 77.4249 167.922 76.799 168.353 76.0463C168.784 75.2936 169.007 74.4408 169 73.5746C168.992 72.7083 168.754 71.8596 168.31 71.1144ZM51.8598 54.8695H46.3334L30.2475 33.5695V54.9186H24.6717V24.5391H30.2475L46.3827 45.8882V24.5391H51.9092L51.8598 54.8695ZM83.0941 29.447H65.676V36.7596H81.4658V41.6675H65.676V49.5691H83.0941V54.4769H60.1002V24.5391H83.0448L83.0941 29.447ZM124 54.7714H118.424L110.776 32.2444L103.128 54.8695H97.6011L87.7324 24.5391H93.7523L100.266 46.2808L107.766 24.5391H113.786L120.99 46.2808L127.552 24.5391H133.622L124 54.7714Z"
      fill="url(#new-item-badge-gradient)"
    />
    <defs>
      <linearGradient
        id="new-item-badge-gradient"
        x1="84.5"
        y1="0"
        x2="84.5"
        y2="78.5253"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF9410" />
        <stop offset="1" stopColor="#FF1D10" />
      </linearGradient>
    </defs>
  </SvgIcon>
);
